export const REMOVE_MESSAGE_ABOUT_DRIVER_TIMEOUT = 10000
